import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { FormMode, Languages, ServiceStatus, RefundMeasFirstReviewerDecision, TransitRequestWFSteps, AgentApproval, TransitType, Direction } from 'src/app/shared/models/enums.model';
import { first } from 'rxjs/operators';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { User } from 'src/app/front-user/shared/models/user.model';
import { TransitRequestCustomDTO } from 'src/app/shared/models/transit-request-custom-dto.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { TransitAdminService } from '../../shared/services/transit-admin.service';
import { CustomValidators } from 'src/app/front-user/shipyard-service/models/custom-validator';
import { TransitAdminDto } from '../../shared/models/transit-admin.model';
import { TransitRequestComponent } from 'src/app/front-user/services/e-booking/transit-request/transit-request.component';
import { TransitService } from 'src/app/front-user/services/e-booking/transit-request/transit-request.service';
import { FeesEstimate } from 'src/app/front-user/services/e-booking/fees-estimation-request/fees-estimate.model';
import { TransitRequestDto } from 'src/app/front-user/services/e-booking/transit-request/transit-request.model';
import { WFHistoryService } from 'src/app/shared/services/wfhistory.service';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';


@Component({
  selector: 'app-Agent-Approval-Limit-time-Rate',
  templateUrl: './Agent-Approval-Limit-time-Rate.component.html',
  styleUrls: ['./Agent-Approval-Limit-time-Rate.component.css']
})
export class AgentApprovalLimittimeRateComponent implements OnInit {

  @ViewChild('transitRequest', { static: false }) transitRequest: TransitRequestComponent;
  displayedLang: string;
  submitted = false;
  baseRequestId: string = '';
  public dateConfig: Partial<BsDatepickerConfig>;
  FeesEstimateObj: FeesEstimate = new FeesEstimate();
  showWarning: boolean = false;
  user: User = new User();
  minTransitDate = new Date();
  decisionValue: number;
  AgentdecisionValue: number;
  isPaid: boolean = false;
  showRequest: boolean = false;
  isArrived: boolean = true;
  TransitDate: Date;
  TransitType: number;
  Direction: number;
  isErrorMessage: boolean = false;
  stepId: number = TransitRequestWFSteps.LimitTimeAcceptance;
  lockTaskErrorMessage: boolean = false;
  transitData: TransitRequestDto = new TransitRequestDto();
  transitRequestCustomObj: TransitRequestCustomDTO = new TransitRequestCustomDTO();
  requestStatuses: number[] = [];
  loading = false;
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  stepData: any;
  AgentstepData: any;
  IsEstimatedFeesPaid: boolean = false;
  baseRequestDTO: BaseRequest;
  decision = AgentApproval;
  decisionKeys = Object.keys(this.decision);
  adminDecisionObject: TransitAdminDto = new TransitAdminDto();
  marineOfficeConfirmationForm: FormGroup;
  agentForm: FormGroup;
  responseObj: ResponseObject = new ResponseObject();
  stepHistoryId: any;
  @Input() public isShow: boolean = true;


  constructor(private formBuilder: FormBuilder, private baseRequestService: BaseRequestService,
    private globalSrv: GlobalServices,
    private transitService: TransitService,
    private wfhistoryService: WFHistoryService,
    private route: ActivatedRoute, private router: Router,
    private translate: TranslateService, private adminSrv: TransitAdminService,
    private authenticationService: AuthenticationService, private alertService: AlertService) {
    this.decisionKeys = this.decisionKeys.slice(this.decisionKeys.length / 2);
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    if (history.state.data && history.state.data.requestId) {
      this.stepHistoryId = history.state.data.stepHistoryId;
      this.baseRequestId = history.state.data.requestId;
      this.getBaseRequest();
    }
    else {
      window.history.back();
    }
    //this.getBaseRequest();
    this.user = this.globalSrv.user;
  }

  ngOnInit() {

    this.globalSrv.isLoaderEnabled = true;
    this.buildForm(null);

    // this.agentForm.get('TransitDate').valueChanges.subscribe(value => {

    //  this.onTransitDateChange(value);
    // });



  }
  onTransitDateChange(value: Date) {

    if (value != undefined) {
      this.AfterLimitTimeRate()
    }
  }

  changeDecision(value) {
    this.decisionValue = value;
    this.buildForm(value);
    this.agentForm.patchValue({
      Decision: value
    });
    if (this.decisionValue == AgentApproval.Accept) {
      this.AfterLimitTimeRate();
    }
  }
  formatDate_DDMMYYYY(date: Date): Date {

    let y = date;
    let z = y.getFullYear();
    let x = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    return x;
  }
  onTimeChanged(date: Date) {
    const hours = date.getHours();
    const minutes = date.getMinutes();

    this.AfterLimitTimeRate()
  }

  AfterLimitTimeRate() {

    const now = new Date();
    const hours = now.getHours(); // current
    const minutes = now.getMinutes(); // current

    let currently = this.formatDate_DDMMYYYY(now); // new selected transit date
    let transitDate = this.formatDate_DDMMYYYY(new Date(this.TransitDate)); // transit request
    if (this.stepData.TimeRate != 12) {
      if (this.Direction == Direction.SouthBound) {
        if (this.TransitType == TransitType.DIRECTTRANSIT) {
          if (this.isSameDay(currently, transitDate)) {
            if (hours == 0) {
              if (this.stepData.TimeRate < 10) {
                this.showWarning = true; // become 10
              }
              else {
                this.showWarning = false;
              }
            }

          }
          else if (this.isPreviousDay(currently, transitDate)) {

            if (hours == 23 && minutes != 0) {
              if (this.stepData.TimeRate < 5) {
                this.showWarning = true; // become 5
              }
              else {
                this.showWarning = false;
              }
            }
            else {
              this.marineOfficeConfirmationForm.patchValue({
                TimeRate: 0,
              });
            }
          }
          else {
            this.showWarning = false;
          }
        }
        else if (this.TransitType == TransitType.LOADINGUNLOADING) {
          this.showWarning = false;
        }
        else if (this.TransitType == TransitType.FROMDAMIETTA) {
          if (this.isSameDay(currently, transitDate)) {
            if (hours == 0) {
              this.showWarning = false;
            }
            else if (hours >= 1) {
              if (this.stepData.TimeRate < 12) {
                this.showWarning = true; // become 12
              }
              else {
                this.showWarning = false;
              }
            }
          }
        }
      }
      else if (this.Direction == Direction.NorthBound) {
        if (this.isSameDay(currently, transitDate)) {
          if (hours == 0) {
            if (this.stepData.TimeRate < 10) {
              this.showWarning = true; // become 10
            }
            else {
              this.showWarning = false;
            }
          }

        }
        else if (this.isPreviousDay(currently, transitDate)) {

          if (hours == 23 && minutes != 0) {
            if (this.stepData.TimeRate < 5) {
              this.showWarning = true; // become 5
            }
            else {
              this.showWarning = false;
            }
          }
          else {
            this.marineOfficeConfirmationForm.patchValue({
              TimeRate: 0,
            });
          }
        }
        else {
          this.showWarning = false;
        }
      }
      else {
        this.showWarning = false;
      }
    }


  }
  buildForm(decision) {
    if (decision == null) {
      this.marineOfficeConfirmationForm = this.formBuilder.group({

        ETA: ['', [Validators.required, CustomValidators.dateValidator()]],
        ETATime: ['', new Date(), [Validators.required]],
        TimeRate: ['', [Validators.required, Validators.pattern(/^[0-9]+$/)]],
        Arrived: ['', [Validators.required]],

      });
    }
    this.agentForm = this.formBuilder.group({
      Decision: ['', [Validators.required]],
    });

    if (decision == AgentApproval.Reject && this.isPaid) {
      this.agentForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        PayFees: ['', [Validators.required]],
      });
    }
    else if (decision == AgentApproval.Reject && !this.isPaid) {
      this.agentForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
      });
    }
    else if (decision == AgentApproval.Edit) {
      this.agentForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        TransitDate: ['', [Validators.required, this.sameAsCurrentTransitDateValidator()]],

      });
    }
    else {
      this.agentForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
      });
    }
  }

  sameAsCurrentTransitDateValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {

      if (!control.value || !this.TransitDate) {
        return null;
      }
      const selectedDate = new Date(control.value);
      const agentTransitDate = new Date(
        this.TransitDate
      );
      if (selectedDate.toDateString() === agentTransitDate.toDateString()) {
        return { sameAsCurrent: true };
      }
      return null;
    };
  }
  getBaseRequest() {
    this.baseRequestService.getBaseRequest(this.baseRequestId).subscribe(
      d => {
        this.baseRequestDTO = d.Data;
        // this.requestStatus = this.baseRequestDTO.StatusId;
        this.requestStatuses = this.baseRequestDTO.RequestStatuses.map(s => s.StatusId);
        this.getTransitRequest();
        if (history.state.data && history.state.data.isCompleted && history.state.data.StepId == this.stepId) { // Request History
          this.formMode = FormMode.Readonly;
          this.getMarineOfficerConfirmationData();
          this.getTransitRequestWFHistoryById();
        }
        else if (!this.requestStatuses.includes(ServiceStatus.Transit_PendingAgentLimitTimeAcceptance)) {
          this.formMode = FormMode.Readonly;
          this.getTransitRequestWFHistory();
        }
        else if (this.requestStatuses.includes(ServiceStatus.Transit_PendingAgentLimitTimeAcceptance)) {
          this.getMarineOfficerConfirmationData();
          this.formMode = FormMode.Add;
        }
      }
    )
  }

  /*getTransitRequestWFHistoryById() {
    this.wfhistoryService.getByRequestIdByStepIdById(this.baseRequestId, this.stepId, this.stepHistoryId).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;

        this.stepData = this.responseObj.Data["StepData"] ? JSON.parse(this.responseObj.Data["StepData"]) : null;
        this.getTransitRequestWFHistoryCompleted(this.stepData);
      }

    );
  }*/
  getMarineOfficerConfirmationData(){
    this.wfhistoryService.getByRequestIdByStepId(this.baseRequestId, TransitRequestWFSteps.ConfirmVesselArrived).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.stepData = this.responseObj.Data["StepData"] ? JSON.parse(this.responseObj.Data["StepData"]) : null;
          this.getMarineOfficerConfirmationDataCompleted(this.stepData);
        }
      }

    );
  }
  getTransitRequestWFHistory() {
    this.wfhistoryService.getByRequestIdByStepId(this.baseRequestId, TransitRequestWFSteps.ConfirmVesselArrived).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.stepData = this.responseObj.Data["StepData"] ? JSON.parse(this.responseObj.Data["StepData"]) : null;
          this.getTransitRequestWFHistoryCompleted(this.stepData);
        }
      }

    );
  }

  getAgentTransitRequestWFHistory() {
    this.wfhistoryService.getByRequestIdByStepId(this.baseRequestId, TransitRequestWFSteps.LimitTimeAcceptance).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.AgentstepData = this.responseObj.Data["StepData"] ? JSON.parse(this.responseObj.Data["StepData"]) : null;
          this.getAgentTransitRequestWFHistoryCompleted(this.stepData);
        }
      }

    );
  }
  getTransitRequestWFHistoryById() {
    this.wfhistoryService.getByRequestIdByStepIdById(this.baseRequestId, this.stepId, this.stepHistoryId).pipe(first()).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        this.stepData = this.responseObj.Data["StepData"] ? JSON.parse(this.responseObj.Data["StepData"]) : null;
        this.getTransitRequestWFHistoryCompleted(this.stepData);
      }
    );
  }

  getAgentTransitRequestWFHistoryCompleted(AgentstepData: any) {

    if (!AgentstepData) return;
    this.AgentdecisionValue = this.AgentstepData.Decision;
    this.agentForm.patchValue({
      Decision: this.AgentdecisionValue
    });

    if (this.AgentdecisionValue == AgentApproval.Edit ) {
      this.agentForm.patchValue({
        Decision: this.AgentdecisionValue,
        TransitDate:this.AgentstepData.TransitDate
      });

    }


  }

  getMarineOfficerConfirmationDataCompleted(stepData: any) {

    if (!stepData) return;
    this.decisionValue = this.stepData.Decision;
    this.marineOfficeConfirmationForm.controls['Arrived']?.setValue(true);
debugger;
    this.marineOfficeConfirmationForm.patchValue({
      ETA: this.stepData.ETA,
      ETATime: this.stepData.ETATime,
      TimeRate: this.stepData.TimeRate,
    });
    this.marineOfficeConfirmationForm.disable();
  }

  getTransitRequestWFHistoryCompleted(stepData: any) {

    if (!stepData) return;
    this.decisionValue = this.stepData.Decision;
    this.marineOfficeConfirmationForm.controls['Arrived']?.setValue(true);
debugger;
    this.marineOfficeConfirmationForm.patchValue({
      ETA: this.stepData.ETA,
      ETATime: this.stepData.ETATime,
      TimeRate: this.stepData.TimeRate,
    });
    this.getAgentTransitRequestWFHistory();
    this.marineOfficeConfirmationForm.disable();
  }

  onSubmit() {

    this.submitted = true;
    if (this.agentForm.invalid) {
      return;
    }

    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;
    this.transitRequestCustomObj.RequestId = this.baseRequestId;
    this.transitRequestCustomObj.IsEstimatedFeesPaid = this.isPaid;


    if (this.decisionValue == this.decision.Edit) {
      this.transitRequestCustomObj.ActualTransitDate = this.agentForm.controls.TransitDate.value;
      if (this.agentForm.controls['TransitDate'].value) {
        this.agentForm.patchValue({
          TransitDate: this.agentForm.controls['TransitDate'].value.toLocaleString('en-US')
        });
      }
    }
    else {
      this.transitRequestCustomObj.ActualTransitDate = this.TransitDate;
    }
    this.transitRequestCustomObj.TransitType = this.TransitType;
    this.transitRequestCustomObj.LimitTimeRate = this.marineOfficeConfirmationForm.controls['TimeRate'].value;
    this.transitRequestCustomObj.StepData = JSON.stringify(this.agentForm.getRawValue());
    this.transitRequestCustomObj.CompletedBy = this.user.UserName;
    this.transitRequestCustomObj.ComponentURL = this.router ? this.router.url.split('/')[1] + '/' + this.router.url.split('/')[2] : '';
    this.transitRequestCustomObj.IsAdmin = this.user.IsAdmin;
    this.transitRequestCustomObj.DirectionId = this.FeesEstimateObj.DirectionId;

    this.transitService.SubmitAgentTimeRateDecision(this.transitRequestCustomObj)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            this.loading = false;
            this.showRequest = true;
            this.isErrorMessage = false;
          }
          else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
          }
          else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            this.loading = false;
          }
        });


  }
  get form() {
    return this.marineOfficeConfirmationForm.controls;
  }
  get form1() {
    return this.agentForm.controls;
  }
  receiveFeesValue($event) {

    this.FeesEstimateObj = $event;
    if (this.baseRequestId && this.FeesEstimateObj) {
      //this.TransitDate = new Date(this.FeesEstimateObj.TransitDate);
      this.Direction = this.FeesEstimateObj.DirectionId;

    }
  }

  isSameDay(date1: Date, date2: Date): boolean {
    return (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate()
    );
  }
  isPreviousDay(dateToCheck: Date, referenceDate: Date): boolean {
    const d1 = new Date(dateToCheck);
    const d2 = new Date(referenceDate);

    // Normalize both dates to midnight
    d1.setHours(0, 0, 0, 0);
    d2.setHours(0, 0, 0, 0);

    // Subtract one day from reference date
    const previousDay = new Date(d2);
    previousDay.setDate(previousDay.getDate() - 1);

    return d1.getTime() === previousDay.getTime();
  }

  public getTransitRequest() {
    this.transitService.get(this.baseRequestId).pipe(first()).subscribe(
      (resObj: ResponseObject) => {

        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.transitData = resObj.Data;
          this.globalSrv.isLoaderEnabled = false;
          this.isPaid = this.transitData.IsEstimatedFeesPaid;
          this.TransitType = this.transitData.TransitType;
          this.TransitDate = this.transitData.AgentTransitDate;
          // this.agentForm.updateValueAndValidity();
          /*var disabledDates  = [new Date(this.TransitDate)];
          /*var disabledDates = mydisabledDates.replace("[", "")
                            .replace("]", "")
                            .split(',')
                            .map(d => new Date(d.trim()));


          this.dateConfig = {

            dateInputFormat: 'YYYY-M-DD',
            datesDisabled: disabledDates ,
          };
          */
        }
      });
  }
}
